<mat-card appearance="outlined" (click)="cardClick$.next()">
  <mat-card-header>
    @if (hasTitle) {
      <mat-card-title>
        {{title}}
      </mat-card-title>
    }
    <mat-card-subtitle>
      {{embedDetails?.provider_name}}
    </mat-card-subtitle>
  </mat-card-header>
  @if (hasImageSrc) {
    <img mat-card-image [src]="imageSrc" (load)="imageLoaded($event)">
  }
  @if (hasContent) {
    <mat-card-content [innerHtml]="htmlContent | unsafeHtml" [ngClass]="embedType"></mat-card-content>
  }
  @if (node?.writeable) {
    <mat-card-actions (click)="stopPropagation($event)" align="end">
      @if (!isInheritedLink && (isAuthorOrAdmin$ | async)) {
        <button mat-raised-button class="pm-remove-link" color="warn" (click)="onRemove($event)">{{'button.remove' | translate}}
        </button>
      }
      <span class="pull-right"></span>
      <pm-color-picker-input [color]="linkColor" (colorChanged)="colorChanged($event)"></pm-color-picker-input>
    </mat-card-actions>
  }
</mat-card>
